import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalService } from '../../shared/services/modal.service';
import { Router } from '@angular/router';
import { RoutePaths } from '../../../core/constants/route-paths';

@Component({
  selector: 'app-policy-page',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  providers: [ModalService],
  templateUrl: './policy-page.component.html',
  styleUrl: './policy-page.component.scss',
})
export class PolicyPageComponent {

  constructor(private readonly _router: Router) { }

  ngOnInit(): void {

  }

  async openCookiesPage(): Promise<void> {
    await this._router.navigate([`${RoutePaths.cookiesPage}`]);
   }

}